import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { useSpring, animated } from "react-spring";
import useImage from "../../../hooks/useImage";

const ProgramPageHeaderWrapper = styled.div`
  .headerImage {
    padding: 50px;
    background-size: cover;
    background-position: center;
  }
  h1 {
    text-align: center;
    padding: 2rem 2rem;
    color: white;
    font-size: 2.5rem;
  }
  .buttonWrapper {
    display: flex;
    justify-content: center;
  }
`;

const ProgramPageHeader = ({
  introPicture,
  completedTokens,
  totalLessonsArray,
  courseId,
  courseTitle,
}) => {
  const [lessonId, setlessonId] = useState(totalLessonsArray[0]);
  const [sectionId, setsectionId] = useState(
    totalLessonsArray[0].mainCategoryId
  );

  const loaded = useImage(introPicture);
  const [start, setstart] = useState(true);
  useEffect(() => {
    for (const programPost of totalLessonsArray) {
      if (completedTokens.indexOf(programPost.programPostId) < 0) {
        setlessonId(programPost.programPostId);
        setsectionId(programPost.mainCategoryId);
        break;
      }
      setstart(false);
    }
  }, [completedTokens, totalLessonsArray]);

  const springProps = useSpring({ opacity: loaded ? 1 : 0 });

  return (
    <ProgramPageHeaderWrapper>
      <animated.div
        className="headerImage"
        style={{ ...springProps, backgroundImage: `url(${introPicture})` }}
      >
        <div>
          <h1>{courseTitle}</h1>
          <div className="buttonWrapper">
            <Link
              to={`/course/${courseId}/section/${sectionId}/post/${lessonId}`}
              className="primaryLink blueBG"
            >
              {start ? `Start Course` : `Resume Course`}
            </Link>
          </div>
        </div>
      </animated.div>
    </ProgramPageHeaderWrapper>
  );
};

export default ProgramPageHeader;
